import { Component, signal } from '@angular/core';
import { FormGroup, Validators, FormBuilder, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';

@Component({
    selector: 'app-backoffice-email-sender',
    templateUrl: './backoffice-email-sender.component.html',
    styleUrls: ['../kb-secure-password/kb-secure-password.component.scss',
    ],
    standalone: false
})
export class BackofficeEmailSenderComponent {
  emailSent = signal<boolean>(false);
  subscription = new Subscription();
  constructor(private formBuilder: FormBuilder,
    public forgotPasswordService: ForgotPasswordService) {

  }
  myForm = new FormGroup({
    email: new FormControl(null, [Validators.required])
  });

  get validEmail() {
    return this.myForm.controls;
  }
  onSubmit() {
    if (this.myForm.valid) {
      this.subscription.add(this.forgotPasswordService.sendEmailToBackEnd(this.myForm.value.email).subscribe((res: any) => {
        if (res.status == 'success') {
          this.emailSent.set(true);
        }
      }));
      this.myForm.reset();
    }
  }
  ngOnDestroy() {
    this.forgotPasswordService.sendSuccessMsg(false);
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();

  }

  emailValidate(control: AbstractControl): ValidationErrors | null {
    const email = control.value;
    const validFormat = /\S+@\S+\.\S+/.test(email);
    console.debug(validFormat ? null : { invalidEmail: true })
    return validFormat ? null : { invalid: true };
  }

}
